import { render, staticRenderFns } from "./bulkData.vue?vue&type=template&id=d415f7a6&scoped=true&"
import script from "./bulkData.vue?vue&type=script&lang=js&"
export * from "./bulkData.vue?vue&type=script&lang=js&"
import style0 from "./bulkData.vue?vue&type=style&index=0&id=d415f7a6&prod&scoped=true&lang=css&"
import style1 from "./bulkData.vue?vue&type=style&index=1&id=d415f7a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d415f7a6",
  null
  
)

export default component.exports